import React, { useState } from "react";
import { toast } from "sonner";
import AppLayout from "../components/AppLayout";
import { Avatar, AvatarFallback, AvatarImage } from "../components/ui/avatar";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../contexts/I18nContext";

export default function Profile() {
  const { user, setUser } = useAuth();
  const { t } = useI18n();
  const [form, setForm] = useState({
    first_name: user?.first_name || "", last_name: user?.last_name || "",
    bio: user?.bio || "", country: user?.country || "", city: user?.city || "",
    avatar_url: user?.avatar_url || "",
  });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.patch("/users/me", form);
      setUser(data);
      toast.success(t("profile_updated"));
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };
  if (!user) return null;
  return (
    <AppLayout>
      <h1 className="font-heading text-3xl sm:text-4xl font-black">{t("profile")}</h1>
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="pp-card p-6 lg:col-span-1">
          <Avatar className="h-24 w-24 mx-auto"><AvatarImage src={form.avatar_url} /><AvatarFallback className="bg-[#00E676] text-black text-2xl font-bold">{(form.first_name?.[0] || "?")}</AvatarFallback></Avatar>
          <div className="text-center mt-4 font-heading text-xl font-bold">{form.first_name} {form.last_name}</div>
          <div className="text-center text-zinc-500 text-sm">{user.email}</div>
          <div className="text-center mt-2"><span className="pp-chip pp-chip-active">{t(user.role) || user.role}</span></div>
        </div>
        <form onSubmit={submit} className="pp-card-elevated p-6 lg:col-span-2 space-y-3" data-testid="profile-form">
          <div className="grid grid-cols-2 gap-3">
            <input data-testid="prof-firstname" className="pp-input" value={form.first_name} onChange={set("first_name")} placeholder={t("first_name")} />
            <input data-testid="prof-lastname" className="pp-input" value={form.last_name} onChange={set("last_name")} placeholder={t("last_name")} />
          </div>
          <input data-testid="prof-avatar" className="pp-input" value={form.avatar_url} onChange={set("avatar_url")} placeholder="Avatar URL" />
          <textarea data-testid="prof-bio" className="pp-input" rows={3} value={form.bio} onChange={set("bio")} placeholder="Bio" />
          <div className="grid grid-cols-2 gap-3">
            <input data-testid="prof-country" className="pp-input" value={form.country} onChange={set("country")} placeholder="Country" />
            <input data-testid="prof-city" className="pp-input" value={form.city} onChange={set("city")} placeholder="City" />
          </div>
          <button data-testid="prof-save" disabled={loading} className="pp-btn-primary px-6 py-3 rounded-xl">{loading ? "..." : t("save")}</button>
        </form>
      </div>
    </AppLayout>
  );
}
